import React from 'react';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { styled, css } from '../theming';
import { Layout } from '../index';
import { ResponsiveProp } from '../utils/responsiveProp';

export type NavBarSectionProps = {
  children: React.ReactNode;
  className?: string;
  direction?: ResponsiveProp<'stack' | 'inline'>;
};

const StyledNavBarSection = styled(Layout)`
  ${({ direction }) => css`
    @media (min-width: ${tokens.viewports.breakpoints[
        direction === 'inline' ? 'xxxsmall' : 'small'
      ]}) {
      gap: ${tokens.size.x6};
    }
  `}
`;

const _NavBarSection = (
  { children, className, direction }: NavBarSectionProps,
  ref?: React.Ref<HTMLDivElement>
): JSX.Element => {
  return (
    <StyledNavBarSection
      ref={ref}
      className={className}
      direction={direction || { xxxsmall: 'stack', small: 'inline' }}
      alignItems={'center'}
    >
      {children}
    </StyledNavBarSection>
  );
};

export const NavBarSection = React.forwardRef(_NavBarSection);
